import React from "react";
import { dispatch } from '@rematch/core';
import { Tab, Label, Menu, Segment, Header, Icon, Checkbox, Image, Popup, Loader } from "semantic-ui-react";
import { toastr } from 'react-redux-toastr';
import dummyAvatar from '../../../../../../images/common/jenny.jpg';
import ContentImage from '../../../../../../images/menu-icons/user/icon-contents.svg';
import ErrorMessage from '../summaryTabs/ErrorMessage'
import NoSummaryData from '../summaryTabs/NoSummaryDataPage'

import convertIcon from "../../../../../../helpers/convert-Icon";
import EllipsisTooltip from "../../../../../common/EllipsisTooltip";
import PlaceholderCardImage from './../../../../../drive/PlaceHolder/PlaceHolderLines'

class ReferenceTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
            selectedContentId: null,
            selectedActivityId: null,
            scope: null,
            referencesData: props.referencesData
        }
    }

    onTabChange = async (event, data) => {
        this.setState({ activeIndex: data.activeIndex });
        this.setState({ _id: null })
        await dispatch.lifeCycle.splitAt(null);
        await dispatch.lifeCycle.showResourecePane(null)

        if (data.activeIndex === 0) {
            this.setState({ scope: null })
        } else if (data.activeIndex === 1) {
            this.setState({ scope: "Private" })
        } else if (data.activeIndex === 2) {
            this.setState({ scope: "Public" })
        }
    }

    handleContent = async (e, content, activity) => {
        e.stopPropagation()
        this.setState({ selectedActivityId: activity._id })
        this.setState({ selectedContentId: content._id })
        await dispatch.content.setSelectedContent(content)
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.lifeCycle.splitAt("60%");
        dispatch.lifeCycle.showResourecePane("SummaryView")
    }

    handleContentType = (e, data) => {
        e.stopPropagation()
        let redirectUrl = data.contentpath.indexOf('://') === -1 ? 'http://' + data.contentpath : data.contentpath
        window.open(redirectUrl, '_blank');
    }

    handleContentDelete = (e, content, activity) => {
        let payload = {
            "content": content,
            "activity": activity
        }
        e.stopPropagation()
        dispatch.createPack.getSelectedActivityAsync(activity._id)

        let message = <div className="confirmMessage">
            <h3>Remove Content</h3>
            <label>{content.name}</label>
            <p>Are you sure to remove this Content from playbook?</p>
        </div>
        toastr.confirm(message, {
            onOk: async () => {
                dispatch.lifeCycle.splitAt(null);
                dispatch.lifeCycle.showResourecePane(null)

                let index;
                for (let i = 0; i < this.props.selectedPracticeFlowActivity.references.length; i++) {
                    if (content._id === this.props.selectedPracticeFlowActivity.references[i].id._id) {
                        index = i;
                    }
                }

                setTimeout(async () => {
                    if (index > -1) {
                        (this.props.selectedPracticeFlowActivity.references).splice(index, 1)
                        await dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
                        await dispatch.content.updatePlaybookRefContent(payload);
                    }
                }, 100);
            }
        });
    }

    componentWillReceiveProps(newProps) {
        if (this.props.referencesData !== newProps.referencesData) {
            this.setState({ referencesData: newProps.referencesData })
        }
        if (this.props.counts.totalPublicRef === 0 || this.props.counts.totalPrivateRef === 0) {
            this.setState({ scope: null })
        }
    }

    getMapping(id) {

        if (this.props.selectedPracticeLibrary.activities) {
            for (let i = 0; i < this.props.selectedPracticeLibrary.activities.length; i++) {
                let activity = this.props.selectedPracticeLibrary.activities[i];
                if (id.toString() === activity._id.toString()) {
                    return activity.name;
                }
                if (activity.activities) {
                    for (let j = 0; j < activity.activities.length; j++) {
                        let subActivity = activity.activities[j];
                        if (id.toString() === subActivity._id.toString()) {
                            return <span>{activity.name} <Icon style={{ marginRight: "5px" }} name="chevron right" />{subActivity.name} </span>;
                        }
                        if (subActivity.activities) {
                            for (let k = 0; k < subActivity.activities.length; k++) {
                                let childActivity = subActivity.activities[k];
                                if (id.toString() === childActivity._id.toString()) {
                                    return <span>{activity.name} <Icon name="chevron right" />{subActivity.name} <Icon name="chevron right" />{childActivity.name}</span>
                                }
                            }
                        }
                    }
                }
            }
        }

    }

    render() {

        const { loadingActivitySummary, selectedOrganisation } = this.props

        let isAuthorized = false;
        this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.participants && this.props.selectedPracticeLibrary.participants.map(participant => {
            if (this.props.user._id === participant.accountUserId && (participant.role === 'author' || participant.role === 'contributor')) {
                isAuthorized = true;
            }
        });

        let isWorkspaceOwner = false;

        if (selectedOrganisation && selectedOrganisation.role === "workspaceOwner") {
            isWorkspaceOwner = true
        }


        let contentErrorList = <div>
            {this.state.referencesData && this.state.referencesData.map((activity, i) => {

                let filterMe = this.state.scope ? activity.references
                    .filter((fd, i) => { return this.state.scope && fd.id.scope === this.state.scope })
                    : activity.references;
                return filterMe && filterMe.length !== 0 && <Segment.Group
                    key={i}
                    size="tiny"
                    className="tabContent">
                    <Header as='h6' attached='top'>
                        <EllipsisTooltip name={this.getMapping(activity._id)} />
                    </Header>
                    {filterMe.map((content, index2) => {
                        let privateContentCheck = this.props.selectedPracticeLibrary.scope === "Public" && content.id.scope === "Private"
                        return <Segment
                            id={content.id._id + "_cont"}
                            key={index2}
                            onClick={(e, data) => this.handleContent(e, content.id, activity)}
                            onDoubleClick={(e, data) => this.handleContent(e, content.id, activity)}
                            className={`${this.state.selectedActivityId === activity._id && this.state.selectedContentId === content.id._id ? 'active' : ''}`}
                            style={{ height: "38px", padding: "10px 15px" }}>
                            <div
                                className="float-left"
                                style={{ width: "calc(100% - 195px)" }}>
                                <Popup
                                    className="popupStyled"
                                    inverted
                                    trigger={
                                        <Icon
                                            name={convertIcon(content.id.type)}
                                            onClick={(e, data) => this.handleContentType(e, content.id, index2)}
                                            className="f_14 float-left text-left"
                                            style={{ width: "20px", color: "#4183c4" }}
                                        />
                                    }
                                    content={`View ${content.id.type}`}
                                />

                                 &nbsp;
                                <div className="float-left" style={{ width: "calc(100% - 30px)" }}>
                                    <EllipsisTooltip
                                     name={content.id.name}
                                     deprecated={content.id.deleted}
                                    //  name={content.id.deleted ? `${content.id.name} (deprecated)` : content.id.name}
                                     />
                                </div>
                            </div>
                            <div className="float-right text-right" style={{ width: "195px" }}>
                                {
                                    content.id.scope === "Private" ?
                                        <span
                                            className={`${privateContentCheck ? "clr-red" : ""}`}>
                                            {
                                                privateContentCheck ?
                                                    <Icon name="warning sign" /> :
                                                    null
                                            }
                                        Workspace Library
                                     </span>
                                        :
                                        <span >
                                            Public Library
                                    </span>
                                }  &nbsp;&nbsp;&nbsp;
                                {
                                    content.id.author ?
                                        <Popup
                                            className="popupStyled"
                                            inverted
                                            trigger={
                                                <Image src={content.id.author.profilePic} avatar />
                                            }
                                            content={
                                                <span>
                                                    {content.id.author.firstName}&nbsp;
                                                {content.id.author.lastName}
                                                </span>
                                            }
                                        /> : null
                                }
                                {this.props.selectedPracticeLibrary.status === 0 && (isAuthorized || isWorkspaceOwner) ?
                                    <Popup
                                        className="popupStyled"
                                        inverted
                                        trigger={
                                            <Icon
                                                className="close-icon"
                                                name="close"
                                                onClick={(e, data) => this.handleContentDelete(e, content.id, activity)} />
                                        }
                                        content="Remove"
                                    /> : null
                                }
                            </div>
                        </Segment>
                    })}
                </Segment.Group>
            })}
        </div>;

        let contentErrorMessage =
            this.props.selectedPracticeLibrary.scope === "Public" && this.props.counts.totalPrivateRef !== 0 ?
                <ErrorMessage
                    errorHead={`${this.props.counts.totalPrivateRef} Content ${this.props.counts.totalPrivateRef === 1 ? "is" : "are"} in Workspace Library`}
                    errorContent={"To Publish this playbook in Public Library, first you will have to update Workspace level content in public library. "} /> :
                null

        let AllTab = {
            menuItem:
                <Menu.Item key='All'>
                    All
                    <Label>
                        {
                            this.props.counts &&
                                this.props.counts.totalRef ?
                                this.props.counts.totalRef : 0
                        }
                    </Label>
                </Menu.Item>,
            render: () => <Tab.Pane className="border-none bg-light-blue" >
                <React.Fragment>
                    {contentErrorMessage}
                    {this.props.totalreference === 0 ?
                        <NoSummaryData type="References" imageName={ContentImage} />
                        :
                        contentErrorList
                    }
                </React.Fragment>

            </Tab.Pane>
        }

        let WorkspaceTab = {
            menuItem:
                <Menu.Item key='Workspace'>
                    Workspace Library <Label>{
                        this.props.counts &&
                            this.props.counts.totalPrivateRef ?
                            this.props.counts.totalPrivateRef : 0
                    }</Label>
                </Menu.Item>,
            render: () => <Tab.Pane className="border-none bg-light-blue">
                {contentErrorMessage}
                {this.props.counts.totalPrivateRef === 0 ?
                    <NoSummaryData type="References" imageName={ContentImage} />
                    :
                    contentErrorList
                }
            </Tab.Pane>
        }

        let Publictab = {
            menuItem:
                <Menu.Item key='Public'>
                    Public Library <Label>{
                        this.props.counts &&
                            this.props.counts.totalPublicRef ?
                            this.props.counts.totalPublicRef : 0
                    }</Label>
                </Menu.Item>,
            render: () => <Tab.Pane className="border-none bg-light-blue">
                {this.props.counts.totalPublicRef === 0 ?
                    <NoSummaryData type="References" imageName={ContentImage} />
                    :
                    contentErrorList
                }
            </Tab.Pane>
        }


        const panes = []
        // panes.push(AllTab)
        // panes.push(WorkspaceTab)
        // panes.push(Publictab)
        if (this.props.counts.totalPrivateRef === 0) {
            panes.push(Publictab)
        } else if (this.props.counts.totalPublicRef === 0) {
            panes.push(WorkspaceTab)
        } else {
            panes.push(AllTab)
            panes.push(WorkspaceTab)
            panes.push(Publictab)
        }
        return (
            <div >
                {loadingActivitySummary ?
                    <PlaceholderCardImage /> :
                    this.props.counts.totalPublicRef === 0 || this.props.counts.totalPrivateRef === 0 ?
                        <div style={{ padding: "0 15px 15px" }} >
                            {contentErrorMessage}
                            {contentErrorList}
                        </div> :
                        <Tab
                            style={{ padding: 0 }}
                            panes={panes}
                            onTabChange={this.onTabChange}
                        />
                }

            </div>
        );
    }
}
export default ReferenceTabs;
